import { render, staticRenderFns } from "./numberItem.vue?vue&type=template&id=1c40271c&scoped=true"
import script from "./numberItem.vue?vue&type=script&lang=js"
export * from "./numberItem.vue?vue&type=script&lang=js"
import style0 from "./numberItem.vue?vue&type=style&index=0&id=1c40271c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c40271c",
  null
  
)

export default component.exports